import DeleteTask from "./DeleteTask";
import EditTask from "./EditTask";

export const ToDo = ({ todo, index, handleEditTask, handleDeleteTask }) => {
  return (
    <>
    
      <div className="col-3">
        <div className="p-2 m-1 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3">
          <h4>{todo.title}</h4>
          <p>Note here</p>
          <EditTask todo={todo} index={index} handleEditTask={handleEditTask} />
          <DeleteTask
            todo={todo}
            index={index}
            handleDeleteTask={handleDeleteTask}
          />
        </div>
      
    </div>
    </>
  );
};
